/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} A11y_Statement_Feedback_TitleInputs */

const en_a11y_statement_feedback_title = /** @type {(inputs: A11y_Statement_Feedback_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Feedback and Contact`)
};

const de_a11y_statement_feedback_title = /** @type {(inputs: A11y_Statement_Feedback_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Feedback und Kontakt`)
};

const fr_a11y_statement_feedback_title = /** @type {(inputs: A11y_Statement_Feedback_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Commentaires et contact`)
};

const es_a11y_statement_feedback_title = /** @type {(inputs: A11y_Statement_Feedback_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comentarios y contacto`)
};

const it_a11y_statement_feedback_title = /** @type {(inputs: A11y_Statement_Feedback_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Feedback e contatto`)
};

const nl_a11y_statement_feedback_title = /** @type {(inputs: A11y_Statement_Feedback_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Feedback en contact`)
};

const pl_a11y_statement_feedback_title = /** @type {(inputs: A11y_Statement_Feedback_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Informacje zwrotne i kontakt`)
};

const fi_a11y_statement_feedback_title = /** @type {(inputs: A11y_Statement_Feedback_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Palaute ja yhteystiedot`)
};

const da_a11y_statement_feedback_title = /** @type {(inputs: A11y_Statement_Feedback_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Feedback og kontakt`)
};

const sv_a11y_statement_feedback_title = /** @type {(inputs: A11y_Statement_Feedback_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Feedback och kontakt`)
};

/**
* | output |
* | --- |
* | "Feedback and Contact" |
*
* @param {A11y_Statement_Feedback_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const a11y_statement_feedback_title = /** @type {((inputs?: A11y_Statement_Feedback_TitleInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<A11y_Statement_Feedback_TitleInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_a11y_statement_feedback_title(inputs)
	if (locale === "fr") return fr_a11y_statement_feedback_title(inputs)
	if (locale === "es") return es_a11y_statement_feedback_title(inputs)
	if (locale === "it") return it_a11y_statement_feedback_title(inputs)
	if (locale === "nl") return nl_a11y_statement_feedback_title(inputs)
	if (locale === "pl") return pl_a11y_statement_feedback_title(inputs)
	if (locale === "fi") return fi_a11y_statement_feedback_title(inputs)
	if (locale === "da") return da_a11y_statement_feedback_title(inputs)
	if (locale === "sv") return sv_a11y_statement_feedback_title(inputs)
	return en_a11y_statement_feedback_title(inputs)
});